<template>
  <div :class="classes">
    <AlertError
      v-if="isError"
      class="alert-icon"
    />
    <AlertWarning
      v-if="!isError"
      class="alert-icon"
    />
    <span
      v-tv:[translationFileName]="message"
    />
  </div>
</template>

<script>
import AlertError from '~/assets/icons/alert_error.svg?component'
import AlertWarning from '~/assets/icons/alert_warning.svg?component'

export default {
  components: {
    AlertError,
    AlertWarning
  },
  props: {
    message: {
      type: [Object, String],
      default() {
        return null
      }
    },
    isError: {
      type: Boolean,
      default() {
        return false
      }
    },
    translationFileName: {
      type: String,
      default() {
        return ''
      }
    }
  },
  computed: {
    classes() {
      return 'warningcontainer--item ' + (this.isError ? 'error-message' : 'warning-message')
    }
  }
}
</script>

<style lang="scss" scoped>
.warningcontainer--item {
  padding: $default-margin-padding-width-small;
  background-color: $color__content--background__primary;
  display: flex;
  flex-direction: row;
  align-items: center;

  .alert-icon {
    padding-right: $default-margin-padding-width-small;
    font-size: map-get($base-text-body-medium, font-size );
  }

  span {
    word-break: break-word;
  }

  &.error-message {
    border: .125rem solid $color--input__border--error;
    color: $color--input__border--error;
  }

  &.warning-message {
    border: .125rem solid $color__default;
    color: $color__default;
  }
}
</style>
